import * as React from 'react';

import { usePropertyListing } from 'src/common/stores/contexts';

import { classNames } from 'uitk-react-utils';

export interface ListingNameProps {
  lineCount?: number;
  visuallyHidden?: boolean;
}

export const ListingName: React.FunctionComponent<ListingNameProps> = ({ lineCount = 1, visuallyHidden = false }) => {
  const { name, recentlyViewed } = usePropertyListing();

  if (visuallyHidden) {
    return <h3 className="is-visually-hidden">{name}</h3>;
  }

  const truncateClass = lineCount && lineCount >= 2 && lineCount <= 9 ? `truncate-lines-${lineCount}` : 'truncate';
  const classes = classNames(`${truncateClass} all-b-padding-half`, {
    'uitk-type-500 pwa-theme--grey-700': recentlyViewed,
    'pwa-theme--grey-900 uitk-type-heading-500': !recentlyViewed,
  });

  return (
    <h3 className={classes} data-stid="content-hotel-title" aria-hidden={true}>
      {name}
    </h3>
  );
};
ListingName.displayName = 'ListingName';
